export class ClientModel {
    public id: number;
    public name: string;
    public email: string;
    public phone: string;
}